
export enum Permission {
  AdministreraAllaAnvändare = "FleetApi.AdministreraAllaAnvändare",
  AdministreraAssistansbolag = "FleetApi.AdministreraAssistansbolag",
  AdministreraAvrop = "FleetApi.AdministreraAvrop",
  AdministreraAvropsinställningar = "FleetApi.AdministreraAvropsinställningar",
  AdministreraFleetCCAvrop = "FleetApi.AdministreraFleetCCAvrop",
  AdministreraEgenProfil = "FleetApi.AdministreraEgenProfil",
  AdministreraExternaKörjournalsrapporter = "FleetApi.AdministreraExternaKörjournalsrapporter",
  AdministreraFöretagsanvändare = "FleetApi.AdministreraFöretagsanvändare",
  AdministreraInformationOchBlanketter = "FleetApi.AdministreraInformationOchBlanketter",
  AdministreraNyheter = "FleetApi.AdministreraNyheter",
  AdministreraOrganisationer = "FleetApi.AdministreraOrganisationer",
  AdministreraSamarbetspartners = "FleetApi.AdministreraSamarbetspartners",
  AdministreraStatusExternKörjournalsrapportering = "FleetApi.AdministreraStatusExternKörjournalsrapportering",
  AdministreraVanligaFrågor = "FleetApi.AdministreraVanligaFrågor",
  FleetDashboard = "FleetApi.FleetDashboard",
  KörSomAnnan = "Säkerhet.KörSomAnnan",
  KilometerRapportering = "FleetApi.KilometerRapportering",
  LoggaUtAnvändare = "FleetApi.LoggaUtAnvändare",
  LäsaBeställDrivmedelskortÄrende = "FleetApi.LäsaBeställDrivmedelskortÄrende",
  LäsaÄndraFöraruppgifterÄrenden = "FleetApi.LäsaÄndraFöraruppgifterÄrenden",
  LäsaEgnaFordon = "FleetApi.LäsaEgnaFordon",
  LäsaFakturor = "FleetApi.LäsaFakturor",
  LäsaFöretagsanvändare = "FleetApi.LäsaFöretagsanvändare",
  LäsaFöretagsbilarSomLöperUt = "FleetApi.LäsaFöretagsbilarSomLöperUt",
  LäsaInformationOchBlanketter = "FleetApi.LäsaInformationOchBlanketter",
  LäsaInnehållRiktatTillAssistantFleetManagers = "FleetApi.LäsaInnehållRiktatTillAssistantFleetManagers",
  LäsaInnehållRiktatTillFleetManagers = "FleetApi.LäsaInnehållRiktatTillFleetManagers",
  LäsaInnehållRiktatTillFörare ="FleetApi.LäsaInnehållRiktatTillFörare",
  LäsaInnehållRiktatTillLöneadministration ="FleetApi.LäsaInnehållRiktatTillLöneadministration",
  LäsaInnehållRiktatTillRedovisning = "FleetApi.LäsaInnehållRiktatTillRedovisning",
  LäsaKonteringsunderlag = "FleetApi.LäsaKonteringsunderlag",
  LäsaNyheter = "FleetApi.LäsaNyheter",
  LäsaPåminnelser = "FleetApi.LäsaPåminnelser",
  LäsaÄndraBilkategoriÄrende = "FleetApi.LäsaÄndraBilkategoriÄrende",
  LäsaÄndraFörareÄrende = "FleetApi.LäsaÄndraFörareÄrende",
  LäsaÄndraKostnadsställeÄrende = "FleetApi.LäsaÄndraKostnadsställeÄrende",
  MätarställningRapportering = "FleetApi.MätarställningRapportering",
  MätarställningRapporteringFöretag = "FleetApi.MätarställningRapporteringFöretag",
  RapportBruttolöneavdrag = "FleetApi.RapportBruttolöneavdrag",
  Rapporteringshistorik = "FleetApi.Rapporteringshistorik",
  RapportFörmånsvärdesammanställning = "FleetApi.RapportFörmånsvärdesammanställning",
  RapportKostnadsöversiktFörare = "FleetApi.RapportKostnadsöversiktFörare",
  RapportKostnadsöversiktFöretag = "FleetApi.RapportKostnadsöversiktFöretag",
  RapportLöneunderlag = "FleetApi.RapportLöneunderlag",
  RapportMiljörapport = "FleetApi.RapportMiljörapport",
  RapportRapporteradKörsträcka = "FleetApi.RapportRapporteradKörsträcka",
  RapportSplittberäkningFörare = "FleetApi.RapportSplittberäkningFörare",
  RapportTotalaKostnader = "FleetApi.RapportTotalaKostnader",
  RapportTransaktionslista = "FleetApi.RapportTransaktionslista",
  RapportVagnsparksöversikt = "FleetApi.RapportVagnsparksöversikt",
  SigneraAvrop = "FleetApi.SigneraAvrop",
  SkapaBeställDrivmedelskortÄrende = "FleetApi.SkapaBeställDrivmedelskortÄrende",
  SkapaÄndraBilkategoriÄrende = "FleetApi.SkapaÄndraBilkategoriÄrende",
  SkapaÄndraFörareÄrende = "FleetApi.SkapaÄndraFörareÄrende",
  SkapaÄndraFöraruppgifterÄrendeEndastAnställningsnummer = "FleetApi.SkapaÄndraFöraruppgifterÄrendeEndastAnställningsnummer",
  SkapaÄndraFöraruppgifterÄrendeAllaUppgifter = "FleetApi.SkapaÄndraFöraruppgifterÄrendeAllaUppgifter",
  SkapaÄndraKostnadsställeÄrende = "FleetApi.SkapaÄndraKostnadsställeÄrende",
  TrängselskattRapportering = "FleetApi.TrängselskattRapportering",
  Vagnparksöversikt = "FleetApi.Vagnparksöversikt"
}
